import React from 'react';
import { Popover } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const ReplaySpeedPopUp = ({ id, open, anchorEl, onClose, children })  => {
    const styles = useStyles();
   
    return(
        <Popover
        id={id}
        classes={{ paper: styles.paper }}
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical:"bottom",
          horizontal: 'center',
        }}
      >
        {children}
      </Popover>
    )
}


const useStyles = makeStyles((theme: any) => ({
   
    paper: {
      overflowX: 'unset',
      overflowY: 'unset',
      backgroundColor: theme.palette.background.paper,
    },
  }));

export default ReplaySpeedPopUp;